import service from "./service";

async function getAlarmList(payload) {
  try {
    const res = service.getAlarmList(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

async function readAlarmOne(payload) {
  try {
    const res = await service.setReadAlarmOne(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

async function unReadAlarmOne(payload) {
  try {
    const res = await service.setUnReadAlarmOne(payload);
    return res;
  } catch (error) {
    console.log(error);
  }
}

async function readAlarmAll() {
  try {
    const res = await service.setReadAlarmAll();
    return res;
  } catch (error) {
    console.log(error);
  }
}

async function getAlarmCount() {
  try {
    const res = await service.getAlarmCount();
    return res;
  } catch (error) {
    console.log(error);
  }
}
// 프로젝트 필터 목록 조회
function getAnnouncement() {
  try {
    const res = service.getAnnouncement();
    return res;
  } catch (error) {
    console.log(error);
  }
}

export default {
  getAlarmList,
  readAlarmOne,
  unReadAlarmOne,
  readAlarmAll,
  getAlarmCount,
  getAnnouncement,
};
